import { GetMainSectionFn } from '../custom-topic-routes'
import { layout } from 'thewest/App.routing'
import { billboardLeaderboardMrec } from 'thewest/routes/ad-units'

export const getYourMoneyRouteInfo: GetMainSectionFn = sectionBuilder => {
    return [
        ...sectionBuilder.getCuratedSection(),
        // Personal Finance
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-paddingNoKicker',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-paddingNoKicker',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-paddingNoKicker',
                        },
                    ],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Personal Finance',
                    headingUrl: '/lifestyle/personal-finance',
                    section: 'lifestyle',
                },

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'personal-finance',
                    topics: ['lifestyle/personal-finance'],
                    includeSubTopics: false,
                    offset: 0,
                    pageSize: 6,
                },
            },
        },
        // Pensions
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Pensions',
                    headingUrl: '/lifestyle/pensions',
                    section: 'lifestyle',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['lifestyle/pensions'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('one'),
        // Superannuation
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Superannuation',
                    headingUrl: '/lifestyle/superannuation',
                    section: 'lifestyle',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['lifestyle/superannuation'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        layout.nestedComposition({
            type: 'janus',
            props: {
                stretchColumns: true,
                verticalSpacing: 'md',
            },
            contentAreas: {
                // Retirement Living
                left: [
                    layout.component({
                        type: 'lima',
                        props: {
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: ['lifestyle/retirement-villages-downsizing'],
                                includeSubTopics: false,
                                paging: {
                                    page: 1,
                                    pageSize: 4,
                                },
                            },
                            sectionHeader: {
                                heading: 'Retirement Living',
                                headingUrl: '/lifestyle/retirement-villages-downsizing',
                                section: 'lifestyle',
                            },
                            verticalSpacing: 'md',
                            fixedRatios: ['16:9'],
                            finalColumns: 2,
                            stretchSelf: true,
                            cardLayout: [
                                ['teaserWithBackground'],
                                [
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                ],
                            ],
                            cardOrientation: {
                                type: 'Landscape-Portrait',
                            },
                        },
                    }),
                ],
                right: [
                    // Aged Care
                    layout.component({
                        type: 'lima',
                        props: {
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: ['lifestyle/aged-care'],
                                includeSubTopics: false,
                                paging: {
                                    page: 1,
                                    pageSize: 4,
                                },
                            },
                            sectionHeader: {
                                heading: 'Aged Care',
                                headingUrl: '/lifestyle/aged-care',
                                section: 'lifestyle',
                            },
                            verticalSpacing: 'md',
                            fixedRatios: ['16:9'],
                            finalColumns: 2,
                            stretchSelf: true,
                            cardLayout: [
                                ['teaserWithBackground'],
                                [
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                ],
                            ],
                            cardOrientation: {
                                type: 'Landscape-Portrait',
                            },
                        },
                    }),
                ],
            },
        }),

        ...billboardLeaderboardMrec('two'),

        layout.nestedComposition({
            type: 'janus',
            props: {
                stretchColumns: true,
                verticalSpacing: 'md',
            },
            contentAreas: {
                // Retirement Investments
                left: [
                    layout.component({
                        type: 'lima',
                        props: {
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: ['lifestyle/retirement-investments'],
                                includeSubTopics: false,
                                paging: {
                                    page: 1,
                                    pageSize: 4,
                                },
                            },
                            sectionHeader: {
                                heading: 'Retirement Investments',
                                headingUrl: '/lifestyle/retirement-investments',
                                section: 'lifestyle',
                            },
                            verticalSpacing: 'md',
                            fixedRatios: ['16:9'],
                            finalColumns: 2,
                            stretchSelf: true,
                            cardLayout: [
                                ['teaserWithBackground'],
                                [
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                ],
                            ],
                            cardOrientation: {
                                type: 'Landscape-Portrait',
                            },
                        },
                    }),
                ],
                right: [
                    // Insurance & Estate Planning
                    layout.component({
                        type: 'lima',
                        props: {
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: ['lifestyle/insurance-estate-planning'],
                                includeSubTopics: false,
                                paging: {
                                    page: 1,
                                    pageSize: 4,
                                },
                            },
                            sectionHeader: {
                                heading: 'Insurance & Estate Planning',
                                headingUrl: '/lifestyle/insurance-estate-planning',
                                section: 'lifestyle',
                            },
                            verticalSpacing: 'md',
                            fixedRatios: ['16:9'],
                            finalColumns: 2,
                            stretchSelf: true,
                            cardLayout: [
                                ['teaserWithBackground'],
                                [
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                    {
                                        type: 'landscape',
                                        format: 'landscape-paddingNoKicker',
                                    },
                                ],
                            ],
                            cardOrientation: {
                                type: 'Landscape-Portrait',
                            },
                        },
                    }),
                ],
            },
        }),

        // Health & Wellbeing
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Health & Wellbeing',
                    headingUrl: '/lifestyle/health-wellbeing',
                    section: 'lifestyle',
                },
                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'health-wellbeing',
                    topics: ['lifestyle/health-wellbeing'],
                    includeSubTopics: false,
                    offset: 0,
                    pageSize: 4,
                },
            },
        },

        ...billboardLeaderboardMrec('three'),

        // Latest
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                loadMoreEnabled: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Latest',
                    section: 'your-money',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['business/your-money'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 8,
                    },
                },
            },
        },
    ]
}
